module.exports = __webpack_public_path__ + "static/media/mobileScreenshot07.634834d1.jpg";